import type { MarketViewListEntry } from "@eu.mdotm.api/sphere";
import { aclByArea, roleByArea } from "$root/functional-areas/acl/checkers/all";
import { validateACLPermissions } from "$root/functional-areas/acl/checkers/shared";
import { getCurrentUser } from "$root/functional-areas/user";
import type { ValidationResult } from "../common/types";
import type { MarketViewActionUnavailableReason, MarketViewListAction } from "./types";

export const marketViewListActionValidators: Record<
	MarketViewListAction,
	(marketView: MarketViewListEntry) => ValidationResult<MarketViewActionUnavailableReason>
> = {
	delete(marketView) {
		const user = getCurrentUser();

		if (!aclByArea.marketView.canDelete(user.id, marketView.richAcl?.acl ?? [])) {
			return [false, "ACL_EDITOR_REQUIRED"];
		}

		return [true, undefined];
	},
	share(marketView) {
		const user = getCurrentUser();

		if (!marketView.richAcl?.acl) {
			return [false, "ACL_EDITOR_REQUIRED"];
		}

		if (!validateACLPermissions(user.id, marketView.richAcl.acl, roleByArea.marketView.OWNER)) {
			return [false, "ACL_OWNER_REQUIRED"];
		}

		return [true, undefined];
	},
};
